import {SalesDashboardRepositoryImpl} from '../repository/SalesDashboardRepositoryImpl';
import {GetInvoicesWithFiltersDashboardUseCase} from '../useCases/GetInvoicesWithFiltersDashboardUseCase';
import {UpdateInvoiceStatusUseCase} from '../useCases/UpdateInvoiceStatusUseCase';
import {RecordPaymentUseCase} from '../useCases/RecordPaymentUseCase';
import {GetPendingBankTransfersUseCase} from '../useCases/GetPendingBankTransfersUseCase';
import {ReviewBankTransferUseCase} from '../useCases/ReviewBankTransferUseCase';
import {GetAgingReportUseCase} from '../useCases/GetAgingReportUseCase';
import {GetInvoiceAttachmentUseCase} from '../useCases/GetInvoiceAttachmentUseCase';
import {UploadInvoiceAttachmentUseCase} from '../useCases/UploadInvoiceAttachmentUseCase';
import {ReplaceInvoiceAttachmentUseCase} from '../useCases/ReplaceInvoiceAttachmentUseCase';
import {DeleteInvoiceAttachmentUseCase} from '../useCases/DeleteInvoiceAttachmentUseCase';

class SalesDashboardFactory {
  private static instance: SalesDashboardFactory | null = null;

  private readonly repo = new SalesDashboardRepositoryImpl();

  private readonly getInvoicesWithFiltersUseCase = new GetInvoicesWithFiltersDashboardUseCase(this.repo);
  private readonly updateInvoiceStatusUseCase = new UpdateInvoiceStatusUseCase(this.repo);
  private readonly recordPaymentUseCase = new RecordPaymentUseCase(this.repo);
  private readonly getPendingBankTransfersUseCase = new GetPendingBankTransfersUseCase(this.repo);
  private readonly reviewBankTransferUseCase = new ReviewBankTransferUseCase(this.repo);
  private readonly getAgingReportUseCase = new GetAgingReportUseCase(this.repo);
  private readonly getInvoiceAttachmentUseCase = new GetInvoiceAttachmentUseCase(this.repo);
  private readonly uploadInvoiceAttachmentUseCase = new UploadInvoiceAttachmentUseCase(this.repo);
  private readonly replaceInvoiceAttachmentUseCase = new ReplaceInvoiceAttachmentUseCase(this.repo);
  private readonly deleteInvoiceAttachmentUseCase = new DeleteInvoiceAttachmentUseCase(this.repo);

  static getInstance (): SalesDashboardFactory {
    if (!this.instance) {this.instance = new SalesDashboardFactory();}
    return this.instance;
  }

  getInvoicesWithFilters () { return this.getInvoicesWithFiltersUseCase; }
  updateInvoiceStatus () { return this.updateInvoiceStatusUseCase; }
  recordPayment () { return this.recordPaymentUseCase; }
  getPendingBankTransfers () { return this.getPendingBankTransfersUseCase; }
  reviewBankTransfer () { return this.reviewBankTransferUseCase; }
  getAgingReport () { return this.getAgingReportUseCase; }
  getInvoiceAttachment () { return this.getInvoiceAttachmentUseCase; }
  uploadInvoiceAttachment () { return this.uploadInvoiceAttachmentUseCase; }
  replaceInvoiceAttachment () { return this.replaceInvoiceAttachmentUseCase; }
  deleteInvoiceAttachment () { return this.deleteInvoiceAttachmentUseCase; }
}

export const salesDashboardFactory = SalesDashboardFactory.getInstance();
